<ion-app>
  @if (isDev) {
    <div class="dev-banner">DEV</div>
  }
  <ion-router-outlet [swipeGesture]="swipe"></ion-router-outlet>
</ion-app>
